module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }